import convertImageToBlob from 'Domain/monitoring/helper/convertImageToBlob';
import moment from 'moment';
import Cookies from 'universal-cookie';

const postCameraViolationPayload = async (data) => {
  const image = await convertImageToBlob(data?.image);
  const cookies = new Cookies();
  const timezone = cookies.get('organization')?.timezone;
  const dateTime = moment.tz(timezone).format('YYYY-MM-DD HH:mm:ss');
  const operatorPresenceId = data?.presence?.id;

  const formData = new FormData();

  formData.append('file', image);
  formData.append('violationTime', dateTime);
  formData.append('operatorPresenceId', operatorPresenceId);
  formData.append('spoofing', data?.isSpoofing);

  return formData;
};

export default postCameraViolationPayload;
